import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const BillingAPI = {
  getUsedCount: function ({ org_id, year, month }) {
    let url = `/organizations/${org_id}/requests-count-by-month`
    let params = { year }
    if (month) {
      url = `/organizations/${org_id}/requests-count-by-day`
      params = { month: month.split('-').reverse().join('-') }
    }
    return axiosInstance.request({
      method: 'GET',
      url,
      params,
    })
  },
  getSubmissionTypeCount: function ({ org_id, year, month }) {
    let url = `/organizations/${org_id}/requests-submission-type-count`
    let params = { year }
    if (month) {
      url = `/organizations/${org_id}/requests-submission-type-count-month`
      params = { month: month.split('-').reverse().join('-') }
    }
    return axiosInstance.request({
      method: 'GET',
      url,
      params,
    })
  },
}

const cancelTokenObject = createCancelToken(BillingAPI)
export default BillingAPI
